module.exports = __webpack_public_path__ + "img/1450290182.79c45977.jpg";